
const Init = function (vm, db, dbStore) {
  console.log('InitCounters() Started ...')
  let result = { Success: false, Data: 'Not implemented!' }
  return new Promise((resolve, reject) => {
    try {
      console.log('Selected Month: ' + vm.selectedMonth)
      console.log('Total Customers: ' + vm.customers.length)
      let promises = []
      for (let s = 0; s < vm.customers.length; s++) {
        let customer = vm.customers[s]
        let promise = GetCustomerPrinters(vm, db, dbStore, customer, vm.selectedMonth).then(function (resultSites) {
          return Promise.resolve(resultSites)
        }).catch(function (err) {
          result = { Success: false, Data: err }
          return Promise.reject({ Success: false, Data: err })
        })
        promises.push(promise)
      }
      Promise.all(promises).then((res) => {
        // console.log(res)
        res.forEach((row) => {
          // console.log(row)
        })
        result = { Success: true, Data: 'All Customers Ready' }
        console.log('InitCounters() Ended')
        // /CountersHistory/Dealers/FdwIBsYWxXNI62fEcDiCaRc1UZt1/Customers/-M1-wBgRNTIALDwhExvf/2021/08/000000000W47A4JKPR1a
        resolve(result)
      }).catch(error => console.log(error))
    } catch (generalError) {
      result = { Success: false, Data: generalError }
      console.log('InitCounters() Ended')
      reject(result)
    }
  })
}

function GetCustomerPrinters (vm, db, dbStore, customer, selectedMonth) {
  let result = { Success: false, Data: 'Not implemented!' }
  try {
    let printers = []
    let printerPathArr = []
    let dealerCustomerKey = customer.DealerKey + '_' + customer.CustomerKey
    console.log(customer)
    console.log('dealerCustomerKey = ' + dealerCustomerKey)
    return db.ref('Printers').orderByChild('DealerCustomerKey').equalTo(dealerCustomerKey).once('value').then((snapPrinters) => {
      const data = snapPrinters.val()
      if (data) {
        const printerKeys = Object.keys(data)
        for (let i = 0; i < printerKeys.length; i++) {
          let printerKey = printerKeys[i]
          let row = data[printerKey]
          let printer = {
            PrinterKey: printerKey,
            SiteKey: row.SiteKey,
            CustomerKey: customer.CustomerKey,
            DealerKey: customer.DealerKey,
            MacAddress: row.MacAddress ? row.MacAddress : pKey,
            PrinterSerial: row.PrinterSerial,
            PageCount: row.PageCount,
            Logged: row.Logged,
            LoggedInt: Number(row.LoggedInt)
          }
          printers.push(printer)
          // for (var m = 1; m <= 12; m++) {
          for (var m = 1; m <= 1; m++) {
            let printerPath = ''
            printerPath += '/CountersHistory'
            printerPath += '/Dealers'
            printerPath += '/' + customer.DealerKey
            printerPath += '/Customers'
            printerPath += '/' + customer.CustomerKey
            printerPath += '/' + selectedMonth
            // printerPath += '/' + printerKey
            printerPathArr.push(printerPath)
            let countersHistory = {
              SiteKey: row.SiteKey,
              StartLogged: '',
              StartCounter: 0,
              EndLogged: '',
              EndCounter: 0,
              DiffCounter: 0
            }
            let loggedPrinter = vm.$moment(printer.Logged, 'YYYY-MM-DD HH:mm:ss')
            let loggedInit = vm.$moment('2021-01-01 00:00:00', 'YYYY-MM-DD HH:mm:ss')
            // let diffMonths = loggedPrinter.diff(loggedInit, 'months')
            let diffMonths = loggedInit.diff(loggedPrinter, 'months')
            // 0AMGBJEK40001QE
            console.log('diffMonths serial [' + printer.PrinterSerial + '] = ' + diffMonths)
            console.log('printer.Logged serial [' + printer.PrinterSerial + '] = ' + printer.Logged)
            if (diffMonths >= 0) {
              if (printer.Logged.indexOf('2020-12') >= 0) {
                countersHistory.StartLogged = printer.Logged
                countersHistory.StartCounter = Number(printer.PageCount)
                countersHistory.EndLogged = printer.Logged
                countersHistory.EndCounter = Number(printer.PageCount)
                countersHistory.DiffCounter = countersHistory.EndCounter - countersHistory.StartCounter
              } else {
                countersHistory.StartLogged = printer.Logged
                countersHistory.StartCounter = Number(printer.PageCount)
                countersHistory.EndLogged = printer.Logged
                countersHistory.EndCounter = Number(printer.PageCount)
                countersHistory.DiffCounter = countersHistory.EndCounter - countersHistory.StartCounter
              }
            }
            console.log(printerPath + '/' + printerKey)
            dbStore.collection(printerPath).doc(printerKey).set(countersHistory).then(function (res) {
              console.log(' :: PrinterKey=' + printerKey + ' IsUpdated= true')
            }).catch(function (err1) {
              console.log(' :: PrinterKey=' + printerKey + ' IsUpdated= false')
            })
          }
        }
        result = { Success: true, Data: printers }
        result = { Success: true, Data: printerPathArr }
        return Promise.resolve(result)
      } else {
        console.log('No printers found for customer: ' + customer.Name)
      }
    }).catch((error) => {
      result = { Success: false, Data: error }
      // console.log(result)
      return Promise.reject(result)
    })
  } catch (generalError) {
    result = { Success: false, Data: generalError }
    return Promise.reject(result)
  }
}

const Load = function (vm, dbStore) {
  console.log('LoadCounters() Started ...')
  let result = { Success: false, Data: 'Not implemented!' }
  console.log('Total Customers: ' + vm.customers.length)
  let customer = vm.customers[0]
  // customer = vm.customers[1]
  console.log('Selected Month: ' + vm.selectedMonth)
  let countersHistoryPath = '/CountersHistory/Dealers/' + customer.DealerKey + '/Customers/' + customer.CustomerKey + '/' + vm.selectedMonth
  console.log('countersHistoryPath: ' + countersHistoryPath)
  let countersHistoryRef = dbStore.collection(countersHistoryPath)
  let countersArr = []
  return countersHistoryRef.get().then(function (snapCounters) {
    console.log('Prev snapCounters.size = ' + snapCounters.size)
    snapCounters.forEach(function (doc) {
      let docData = doc.data()
      countersArr.push({
        DocID: doc.id,
        DiffCounter: docData.DiffCounter,
        EndCounter: docData.EndCounter,
        EndLogged: docData.EndLogged,
        SiteKey: docData.SiteKey,
        StartCounter: docData.StartCounter,
        StartLogged: docData.StartLogged
      })
    })
    result = {
      Success: true,
      Data: {
        DealerKey: customer.DealerKey,
        CustomerKey: customer.CustomerKey,
        CountersArr: countersArr
      }
    }
    return Promise.resolve(result)
  }).catch(function (err) {
    return Promise.reject(err)
  })
}

const Get = function (vm, dbStore) {
  console.log('GetHistoryCounters() Started ...')
  let result = { Success: false, Data: 'Not implemented!' }
  console.log('Total Customers: ' + vm.customers.length)
  let customer = vm.customers[0]
  // customer = vm.customers[1]
  console.log('Selected Month: ' + vm.selectedMonth)
  let startDateString = vm.selectedMonth + '/01'
  let prevMonthString = vm.$moment(vm.selectedMonth, 'YYYY/MM').add(-1, 'months').format('YYYY/MM')
  let startDate = vm.$moment(startDateString, 'YYYY/MM/DD').add(-1, 'months')
  let endDate = vm.$moment(startDateString, 'YYYY/MM/DD').add(-1, 'months').endOf('month')
  let LoggedIntFrom = Number(vm.$moment(startDate).format('YYYYMMDD') + '0000')
  let LoggedIntTo = Number(vm.$moment(endDate).format('YYYYMMDD') + '2359')
  let strLoggedIntFrom = LoggedIntFrom + ''
  let strLoggedIntTo = LoggedIntTo + ''
  console.log('prevMonthString: ' + prevMonthString)
  console.log('strLoggedIntFrom: ' + strLoggedIntFrom)
  console.log('strLoggedIntTo: ' + strLoggedIntTo)
  let printersPrevPath = '/PrintersHistory/Dealers/' + customer.DealerKey + '/Customers/' + customer.CustomerKey + '/' + prevMonthString
  let printersPath = '/PrintersHistory/Dealers/' + customer.DealerKey + '/Customers/' + customer.CustomerKey + '/' + vm.selectedMonth
  let printersPrevRef = dbStore.collection(printersPrevPath)
  let printersRef = dbStore.collection(printersPath)
  console.log('printersPrevPath: ' + printersPrevPath)
  console.log('printersPath: ' + printersPath)
  let countersPrevArr = []
  let countersArr = []
  let includePrevMonth = true
  /*
  let printersArr = []
  let printersRef = db.ref(printersPath)
  let dealerCustomerKey = vm.$root.filter.dealerKey + '_' + vm.$route.params.customerKey
  printersRef.orderByChild('DealerCustomerKey').equalTo(dealerCustomerKey).on('value', (snapPrinters) => {
  })
  */
  return printersRef.get().then(function (snapPrinters) {
    console.log('snapPrinters.size = ' + snapPrinters.size)
    snapPrinters.forEach(function (doc) {
      let docData = doc.data()
      if (Number(docData.PageCount) > 0) {
        countersArr.push({
          DocID: doc.id,
          MacAddress: docData.MacAddress,
          PageCount: docData.PageCount,
          Logged: docData.Logged,
          LoggedInt: Number(docData.LoggedInt),
          SiteKey: docData.SiteKey
        })
      }
    })
    result = {
      Success: true,
      Data: {
        PrevCounters: [],
        CurrentCounters: countersArr
      }
    }
    if (includePrevMonth) {
      return printersPrevRef.get().then(function (snapPrevPrinters) {
        console.log('snapPrevPrinters.size = ' + snapPrevPrinters.size)
        snapPrevPrinters.forEach(function (docPrev) {
          let docPrevData = docPrev.data()
          if (Number(docPrevData.PageCount) > 0) {
            countersPrevArr.push({
              DocID: docPrev.id,
              MacAddress: docPrevData.MacAddress,
              PageCount: docPrevData.PageCount,
              Logged: docPrevData.Logged,
              LoggedInt: Number(docPrevData.LoggedInt),
              SiteKey: docPrevData.SiteKey
            })
          }
        })
        result.Data.PrevCounters = countersPrevArr
        return Promise.resolve(result)
      }).catch(function (err2) {
        return Promise.reject(err2)
      })
    } else {
      return Promise.resolve(result)
    }
  }).catch(function (err1) {
    return Promise.reject(err1)
    // test
  })
}

const Update = function (vm, dbStore, counter, collectionPath, PrevCountersDescending, CurrentCountersDescending, CurrentCountersAscending) {
  console.log('UpdateHistoryCounters() Started ...')
  let result = { Success: false, Data: 'Not implemented!' }
  let prevCounter = PrevCountersDescending.find((c) => c.MacAddress === counter.DocID)
  let currentCounter = CurrentCountersDescending.find((c) => c.MacAddress === counter.DocID)
  let isUpdated = false
  if (prevCounter) {
    counter.StartCounter = Number(prevCounter.PageCount)
    counter.StartLogged = prevCounter.Logged
    if (!currentCounter) {
      if (counter.EndLogged.length === 0) {
        counter.EndCounter = counter.StartCounter
        counter.EndLogged = counter.StartLogged
      }
    }
    isUpdated = true
    console.log('PrinterKey=' + counter.DocID + ' PREV FOUND in [PrevCountersDescending] ****** ' + prevCounter.Logged)
  } else {
    // Get first record in Current Counters:
    prevCounter = CurrentCountersAscending.find((c) => c.MacAddress === counter.DocID)
    if (prevCounter) {
      counter.StartCounter = Number(prevCounter.PageCount)
      counter.StartLogged = prevCounter.Logged
      if (!currentCounter) {
        if (counter.EndLogged.length === 0) {
          counter.EndCounter = counter.StartCounter
          counter.EndLogged = counter.StartLogged
        }
      }
      isUpdated = true
      console.log('PrinterKey=' + counter.DocID + ' PREV FOUND in [CurrentCountersAscending] ****** ' + prevCounter.Logged)
    } else {
      console.log('PrinterKey=' + counter.DocID + ' PREV Missing >>>>>>>>>>>>>>>>>>>>> ****** ')
    }
  }
  if (currentCounter) {
    counter.EndCounter = Number(currentCounter.PageCount)
    counter.EndLogged = currentCounter.Logged
    if (!prevCounter) {
      if (counter.StartLogged.length === 0) {
        counter.StartCounter = counter.EndCounter
        counter.StartLogged = counter.EndLogged
      }
    }
    isUpdated = true
    console.log('PrinterKey=' + counter.DocID + ' CURRENT FOUND in [CurrentCountersDescending] ****** ' + currentCounter.Logged)
  } else {
    counter.EndCounter = counter.StartCounter
    counter.EndLogged = counter.StartLogged
    /*
    if (!prevCounter) {
      if (counter.StartLogged.length === 0) {
        counter.StartCounter = counter.EndCounter
        counter.StartLogged = counter.EndLogged
      }
      if (counter.EndLogged.length === 0) {
        counter.EndCounter = counter.StartCounter
        counter.EndLogged = counter.StartLogged
      }
    } else {
      console.log(' :: PrinterKey=' + counter.DocID + ' CURRENT Missing >>>>>>>>>>>>>>>>>>>>> ****** ')
    }
    */
    console.log(' :: PrinterKey=' + counter.DocID + ' CURRENT Missing >>>>>>>>>>>>>>>>>>>>> ****** ')
  }
  if (!isNaN(counter.EndCounter) && !isNaN(counter.StartCounter)) {
    counter.DiffCounter = Number(counter.EndCounter) - Number(counter.StartCounter)
    if (counter.DiffCounter < 0) {
      counter.DiffCounter = 'Error'
    }
    isUpdated = true
  }
  console.log(counter)
  let docID = counter.DocID
  if (isUpdated) {
    delete counter.DocID
    return dbStore.collection(collectionPath).doc(docID).set(counter).then(function (res) {
      // console.log(' :: PrinterKey=' + docID + ' IsUpdated= true')
      result = { Success: true, Data: 'PrinterKey=' + docID + ' IsUpdated= true' }
      return Promise.resolve(result)
    }).catch(function (err) {
      console.log(err)
      // console.log(' :: PrinterKey=' + docID + ' IsUpdated= false')
      result = { Success: false, Data: 'PrinterKey=' + docID + ' IsUpdated= false' }
      return Promise.resolve(result)
    })
  } else {
    result = { Success: false, Data: 'PrinterKey =' + docID + 'No Data for Update !' }
    return Promise.resolve(result)
  }
}

export const HistoryCounters = {
  Init: Init,
  Load: Load,
  Get: Get,
  Update: Update
}



// WEBPACK FOOTER //
// ./src/plugins/countersHistory.js